<div class="white-box contact_support">
  <div class="content">
    <div class="section-title">
      <h3>{{'help.contactSupport.title'|translate}}</h3>
      <h4 class="mb-4 mt-4">{{'help.contactSupport.sub_title.1'|translate}}</h4>
      <p><a href="mailto:{{'help.contactSupport.email'|translate}}">{{'help.contactSupport.email'|translate}}</a></p>
      <h4 class="mt-4">{{'help.contactSupport.sub_title.2'|translate}}</h4>
    </div>
  </div>
</div>
